module.exports = __webpack_public_path__ + "img/banner_2.f61c3748.png";